<template>
  <div class="box">
    <div class="bg">
      <img class="bg-img" src="@/assets/images/bg.png" alt="" />
    </div>
    <img class="logo-img" src="@/assets/images/logo.png" alt="" />
    <div class="login-box">
      <div class="title">验证登录</div>
      <!-- 身份证/法人身份证、组织代码登录选项卡 -->
      <van-tabs v-model="activeTab" @click="changeTab" background="#fff" color="#E99D42" line-width="60px" line-height="4px">
        <van-tab title="身份证/法人身份证">
          <div class="field-wrapper">
            <van-field v-model="form.userIdCard" label="身份证" clearable label-width="70px" placeholder="输入身份证或法人身份证" left-icon="contact" />
          </div>
        </van-tab>
        <van-tab title="统一社会代码">
          <div class="field-wrapper">
            <van-field v-model="form.unifiedSocialCreditCode" label="统一社会代码" clearable label-width="90px" placeholder="请输入统一社会代码" left-icon="contact" />
          </div>
        </van-tab>
      </van-tabs>
      <div class="confirm">
        <van-button class="confirm-btn" color="#E99D42" @click="login" :disabled="loading">
          <div>登录</div>
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { loginByTeam } from '@/service/insurance'
// import { loginByIdcard, loginByPhone } from '@/service/insurance'
export default {
  props: {},
  data() {
    return {
      activeTab: 0,
      form: {
        userIdCard: '',
        unifiedSocialCreditCode: '',
        grantType: 'individualInsuranceLogin',
        clientId: '428a8310cd442757ae699df5d894f051'
      },
      loading: false,
      token: ''
    }
  },
  mounted() {},
  methods: {
    login() {
      if (this.activeTab === 0) {
        if (!this.form.userIdCard) {
          this.$toast.fail('请输入身份证号')
          return
        }
      } else {
        if (!this.form.unifiedSocialCreditCode) {
          this.$toast.fail('请输入统一社会代码')
          return
        }
      }
      this.loading = true
      console.log(this.form)
      // 调用登录接口
      loginByTeam(this.form)
        .then((res) => {
          console.log(res)
          sessionStorage.setItem('Authorization', 'Bearer ' + res.data.access_token)
          this.loading = false
          setTimeout(() => {
            this.$router.replace('/team/form')
          }, 100)
        })
        .catch(() => {
          this.$toast.fail('登录失败，请检查输入信息是否正确')
          this.loading = false
        })
    },
    changeTab(tab) {
      this.activeTab = tab
      // 清空表单数据
      this.form.userIdCard = ''
      this.form.unifiedSocialCreditCode = ''
    }
  }
}
</script>

<style lang="stylus" scoped>
body{
  width: 100%
  .box{
    height: 100vh
    overflow-y: scroll
    .bg{
      z-index: -1
      position: absolute
      height: 100%
      width: 100%
      .bg-img{
        width: 100%
        height: 100%
      }
    }
    .logo-img{
      margin: 20px
      width: 300px
    }
    .login-box{
      background: rgba(255,255,255,0.6)
      width: 650px
      // height: 500px
      border-radius: 20px
      margin: 330px auto 30px auto
      padding: 30px
      .title {
        font-size: 52px
        font-weight: bold
        text-align: center
        margin: 0 auto 100px auto
      }
      .confirm{
        margin: 30px auto
        text-align: center
        .confirm-btn{
          border-radius: 20px
          width: 580px
        }
      }
    }
  }
}
</style>
